import { createUnderline, font15, mq } from '@/styles'
import { memo } from 'react'
import styled from 'styled-components'

// PENDING FIX, PROBABLY WILL BE REMOVED
interface IContentButtonDownload {
  data: {
		media: {
			name: string
			download: {
				url: string
			}
		}
	}
}

export const ContentButtonDownload = memo(({ data }: IContentButtonDownload) => {
  const { media } = data
  const { download } = media

  const onClick = () => {
    window.open(download.url)
  }
  return (
    <ButtonDownload onClick={onClick} >
      <span>{media.name}</span>
    </ButtonDownload>
  )
})

const ButtonDownload = styled.button`
  align-items: flex-start;
  display: flex;
  
  > span {
    ${createUnderline({ reverse: true })}
    ${font15(true, 400)}
    text-align: center;

    ${mq.greaterThan('tablet')} {
      ${font15(false, 400)}
    }
  }
`
